import { AxiosResponse } from "axios";
import axios from "axios";
import { axiosInstance } from "../axios-instance";
const getBranches = "branches";
const branche = "branche";
const getMenu = "sections";
const getCategory = "categories";
const getProduct = "products";
const getProductById = "product";
const settings = "settings";
const selectedProduct = "selected-products";
const privacyPolicy = "privacy-policy";

// Base URL للـ API بدون /customer
const API_BASE_URL = "https://kriechapi.krieshrestaurant.com/api";

const menuServices = {
  getBranches: (): Promise<AxiosResponse> =>
    axiosInstance().post(`${getBranches}`),
  getMenu: ({ branch_id }: any): Promise<AxiosResponse> =>
    axiosInstance().post(`${getMenu}`, { branch_id }),
  getCategory: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`${getCategory}`, payload),
  getProduct: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`${getProduct}`, payload),
  getProductById: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`${getProductById}/${payload.productId}`, payload),

  getBranche: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`${branche}`, payload),
  getSettings: (): Promise<AxiosResponse> =>
    axiosInstance().get(`${settings}`),
  ////////////////////////////////////////////////////////
  searchProduct: (params: any): Promise<AxiosResponse> =>
    axiosInstance().post(`search`, params),
  selectedProduct: (payload: any): Promise<AxiosResponse> =>
    axiosInstance().post(`${selectedProduct}`, payload),
  // استخدام baseURL مختلف بدون /customer
  getPrivacyPolicy: (): Promise<AxiosResponse> =>
    axios.get(`${API_BASE_URL}/${privacyPolicy}`),
};


export default menuServices;
